/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { OrbitalApesLimitedController } from "../OrbitalApesLimitedController";

export class OrbitalApesLimitedController__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _mintToken: string,
    _mintContract: string,
    overrides?: Overrides
  ): Promise<OrbitalApesLimitedController> {
    return super.deploy(
      _mintToken,
      _mintContract,
      overrides || {}
    ) as Promise<OrbitalApesLimitedController>;
  }
  getDeployTransaction(
    _mintToken: string,
    _mintContract: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      _mintToken,
      _mintContract,
      overrides || {}
    );
  }
  attach(address: string): OrbitalApesLimitedController {
    return super.attach(address) as OrbitalApesLimitedController;
  }
  connect(signer: Signer): OrbitalApesLimitedController__factory {
    return super.connect(signer) as OrbitalApesLimitedController__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OrbitalApesLimitedController {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as OrbitalApesLimitedController;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_mintToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_mintContract",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "max",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "active",
        type: "bool",
      },
    ],
    name: "tokenUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mintContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_mintContract",
        type: "address",
      },
    ],
    name: "setMintContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_mintToken",
        type: "address",
      },
    ],
    name: "setMintToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokens",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "max",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "active",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "max",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "active",
        type: "bool",
      },
    ],
    name: "updateToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "addresses",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "whitelistAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "whitelistMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "whitelists",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
